import React, { Component } from 'react'
import { ChallengePanelStyle } from './../../../../styles'
import { RankingIQ, CurrentRanking, PushContent, PushQuizz, PushHighScore, ArrowDrop } from './../../../../components'
import { connect } from 'react-redux'
import URL from './../../../../static/montre.jpg'
import Router from './../../../../services/Router'

const CHALLENGE_ROLE = [
  'ROLE_SELLER',
  'ROLE_STORE_MANAGER',
]

class Challenge extends Component {

  render() {
    const { role, menu, load } = this.props
    const { gift } = menu.challenge
    return (
      <div className={`page-inner panel-challenge ${ChallengePanelStyle(URL, load)}`}>
        <div className="panel-challenge-content">
          <div className="flex challenge-panel-top">
            <div className="challenge-panel-title">
              <h2 className="title">Challenge</h2>
              {/* <span className="subtitle"> and win amazing gifts </span> */}
            </div>
            {
              CHALLENGE_ROLE.indexOf(role) !== -1 && (
                <div className="challenge-panel-ranking flex">
                  <div className="ranking-push">
                    <CurrentRanking preview />
                  </div>
                  <div className="ranking-push">
                    <RankingIQ preview />
                  </div>
                </div>
              )
            }
          </div>
          <div className="challenge-panel-push flex">
            {
              gift && (
                <div className="push">
                  <PushContent {...gift} description='' page={Router.hubQuizz.path} label='Discover' picture={gift.image} />
                </div>
              )
            }
            
            <div className="push">
              <PushQuizz />
            </div>
            {/* <div className="push"> 
              <PushHighScore />
            </div>*/}
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  ({ Session }) => ({
    menu: Session.menu,
    role: Session.role,
  })
)(Challenge)


// WEBPACK FOOTER //
// ./src/scenes/Layout/BaseLayout/Panel/Challenge.js